import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import {
  errorMessageAtom,
  isInProgressAtom,
  successMessageAtom,
} from '../atoms/messageBarAtoms';
import { downloadCsvWithTimestamp } from '../utils/csvHelpers';

export const useExportCsv = (
  exportApi: (abortController: AbortController) => Promise<string>,
  fileNamePrefix: string
) => {
  const setIsInProgress = useSetAtom(isInProgressAtom);
  const setSuccessMessage = useSetAtom(successMessageAtom);
  const setErrorMessage = useSetAtom(errorMessageAtom);

  return useCallback(async () => {
    const abortController = new AbortController();
    setIsInProgress(true);
    try {
      const csvContent = await exportApi(abortController);
      downloadCsvWithTimestamp(fileNamePrefix, csvContent);
      setSuccessMessage('Export completed. CSV downloaded.');
    } catch (error: any) {
      console.error('Error:', error);
      setErrorMessage(error.message);
    } finally {
      setIsInProgress(false);
    }
  }, [
    exportApi,
    fileNamePrefix,
    setIsInProgress,
    setSuccessMessage,
    setErrorMessage,
  ]);
};
